import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  class: "modal-header",
  id: "mau_modal_add_oganizacion_header"
}
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  id: "mau_modal_add_oganizacion_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" })
], -1)
const _hoisted_6 = {
  class: "scroll-y",
  id: "mau_modal_add_oganizacion_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#mau_modal_add_oganizacion_header",
  "data-kt-scroll-wrappers": "#mau_modal_add_oganizacion_scroll",
  "data-kt-scroll-offset": "200px"
}
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "row mb-6" }
const _hoisted_15 = { class: "col col-form-label fw-bold fs-6" }
const _hoisted_16 = { class: "col-lg-8 fv-row" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = { class: "col col-form-label fw-bold fs-6" }
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "row mb-6" }
const _hoisted_25 = { class: "col col-form-label fw-bold fs-6" }
const _hoisted_26 = { class: "col-lg-8 fv-row" }
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col col-form-label fw-bold fs-6" }
const _hoisted_31 = { class: "col-auto col-form-label fv-row" }
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_35 = { class: "col-12 fv-row" }
const _hoisted_36 = ["placeholder"]
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "modal-footer flex-center" }
const _hoisted_40 = {
  type: "reset",
  id: "mau_modal_add_oganizacion_cancel",
  class: "btn btn-light me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_41 = ["data-kt-indicator", "disabled"]
const _hoisted_42 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_43 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

import { useModal } from "@/composable";
import tratamientos from "@/core/data/tratamiento";
import { hideModal } from "@/core/helpers/dom";
import { NuevoMenor } from "@/store/models";
import FamiliasModule from "@/store/modules/FamiliasModule";
import { ElMessage } from "element-plus";
import { ErrorMessage, useField, useForm } from "vee-validate";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import * as Yup from "yup";


export default /*#__PURE__*/_defineComponent({
  props: {
  menor: {
    type: Object as () => NuevoMenor,
    required: false,
  },
},
  setup(__props) {

const props = __props

const store = useStore();
const module = getModule(FamiliasModule, store);
const { t } = useI18n();
const isCreate = computed(() => !props.menor?.id);


const { modalRef, isShown } = useModal();

onMounted(() => {
  resetForm({
    values: {
      tratamiento: "",
      nombre: "",
      apellidos: "",
      fechaNacimiento: new Date(),
      tienePatologias: false,
      patologiasObservaciones: "",
    },
  });
});

watch(
  () => [props.menor, isShown.value],
  () => {
    if (!props.menor) {
      return resetForm({
        values: {
          tratamiento: "",
          nombre: "",
          apellidos: "",
          fechaNacimiento: new Date(),
          tienePatologias: false,
          patologiasObservaciones: "",
        },
      });
    }

    return resetForm({
      values: {
        tratamiento: props.menor.tratamiento,
        nombre: props.menor.nombre,
        apellidos: props.menor.apellidos,
        fechaNacimiento: props.menor.fechaNacimiento,
        tienePatologias: props.menor.tienePatologias ?? false,
        patologiasObservaciones: props.menor.patologiasObservaciones ?? "",
      },
    });
  }
);

const validationSchema = Yup.object({
  id: Yup.string(),
  tratamiento: Yup.string()
    .required()
    .label(t("menores.formulario.tratamiento")),
  nombre: Yup.string().required().label(t("menores.formulario.nombre")),
  apellidos: Yup.string().required().label(t("menores.formulario.apellidos")),
  fechaNacimiento: Yup.date()
    .required()
    .label(t("menores.formulario.fechaNacimiento")),
  tienePatologias: Yup.boolean()
    .required()
    .label(t("menores.formulario.tienePatologias")),
  patologiasObservaciones: Yup.string()
    .ensure()
    .when("tienePatologias", {
      is: true,
      then: Yup.string()
        .required()
        .label(t("menores.formulario.patologiasObservaciones")),
    }),
});
const { handleSubmit, resetForm, meta } = useForm<NuevoMenor>({
  validationSchema,
});
const { value: tratamiento } = useField("tratamiento");
const { value: nombre } = useField("nombre");
const { value: apellidos } = useField("apellidos");
const { value: fechaNacimiento } = useField("fechaNacimiento");
const { value: tienePatologias } = useField("tienePatologias");
const { value: patologiasObservaciones } = useField("patologiasObservaciones");

const loading = ref(false);
const submit = handleSubmit(async (values) => {
  if (!values.tienePatologias) {
    values.patologiasObservaciones = "";
  }

  try {
    loading.value = true;
    isCreate.value
      ? await module.addMenor(values)
      : await module.updateMenor({ ...values, id: props.menor?.id });

    await module.fetchMenores();
    loading.value = false;

    ElMessage.success(
      isCreate.value
        ? t("menores.añadirMenor.success")
        : t("menores.updateMenor.success")
    );

    hideModal(modalRef.value);
  } catch (error) {
    loading.value = false;

    ElMessage.error(
      isCreate.value
        ? t("menores.añadirMenor.error")
        : t("menores.updateMenor.error")
    );
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "mau_modal_add_menor",
    ref_key: "modalRef",
    ref: modalRef,
    tabindex: "-1",
    "aria-hidden": "true",
    "aria-modal": "true",
    "aria-label": "Crear Menor",
    role: "dialog"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$props.menor ? _ctx.$t("menores.modal.edit") : _ctx.$t("menores.modal.add")), 1),
          _hoisted_5
        ]),
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("menores.formulario.tratamiento")), 1),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("select", {
                    name: "tratamiento",
                    class: "w-100 form-select form-select-solid",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tratamiento) ? (tratamiento).value = $event : null))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tratamientos), (tratamiento, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: i,
                        value: tratamiento.id
                      }, _toDisplayString(tratamiento.text), 9, _hoisted_11))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(tratamiento)]
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_unref(ErrorMessage), { name: "tratamiento" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("menores.formulario.nombre")), 1),
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "nombre",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(nombre) ? (nombre).value = $event : null)),
                    class: "form-control form-control-solid"
                  }, null, 512), [
                    [_vModelText, _unref(nombre)]
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_unref(ErrorMessage), { name: "nombre" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("menores.formulario.apellidos")), 1),
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "apellidos",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(apellidos) ? (apellidos).value = $event : null)),
                    class: "form-control form-control-solid"
                  }, null, 512), [
                    [_vModelText, _unref(apellidos)]
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_unref(ErrorMessage), { name: "apellidos" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("menores.formulario.fechaNacimiento")), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_el_date_picker, {
                    format: "DD/MM/YYYY",
                    name: "fechaNacimiento",
                    modelValue: _unref(fechaNacimiento),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(fechaNacimiento) ? (fechaNacimiento).value = $event : null)),
                    type: "date",
                    class: "w-100 custom-datepicker",
                    "disabled-date": (date) => date.getTime() > Date.now()
                  }, null, 8, ["modelValue", "disabled-date"]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_unref(ErrorMessage), { name: "fechaNacimiento" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("menores.formulario.tienePatologias")), 1),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_el_switch, {
                    modelValue: _unref(tienePatologias),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(tienePatologias) ? (tienePatologias).value = $event : null))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_unref(ErrorMessage), { name: "tienePatologias" })
                    ])
                  ])
                ])
              ]),
              (_unref(tienePatologias))
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(patologiasObservaciones) ? (patologiasObservaciones).value = $event : null)),
                        type: "textarea",
                        placeholder: 
                      _ctx.$t('menores.formulario.patologiasObservaciones')
                    ,
                        class: "form-control form-control-solid"
                      }, null, 8, _hoisted_36), [
                        [_vModelText, _unref(patologiasObservaciones)]
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_unref(ErrorMessage), { name: "tienePatologias" })
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("button", _hoisted_40, _toDisplayString(_ctx.$t("global.buttons.cancelar")), 1),
          _createElementVNode("button", {
            "data-kt-indicator": loading.value ? 'on' : null,
            class: "btn btn-lg btn-primary",
            type: "submit",
            disabled: !_unref(meta).valid || !_unref(meta).dirty,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(submit)()))
          }, [
            (!loading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_unref(isCreate)
                  ? _ctx.$t("global.buttons.add")
                  : _ctx.$t("global.buttons.update")), 1))
              : _createCommentVNode("", true),
            (loading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                  _createTextVNode(_toDisplayString(_unref(isCreate)
                  ? _ctx.$t("global.buttons.addLoading")
                  : _ctx.$t("global.buttons.updateLoading")) + " ", 1),
                  _hoisted_44
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_41)
        ])
      ])
    ])
  ], 512))
}
}

})